import React, { useState, useEffect, useRef } from 'react';
import './Style/PDFViewer.css';
import { Link, useParams } from 'react-router-dom';
import TopNavbar from '../home/TopNavbar';
import PdfFiles from "../AllData/PdfFiles";
import { OnlineStatus } from '../Component/OnlineStatus';




const PDFCard = ({ type, subject, topic, pdfFile, title, fileId }) => {

    const isOnline = OnlineStatus();


    const [downloadState, setDownloadState] = useState({
        isLoading: false,
        progress: 0,
        status: 'idle', // 'idle', 'downloading', 'complete', 'error'
        blobUrl: null,
        showOpenButton: false
    });

    const handleDownload = async () => {
        setDownloadState({
            ...downloadState,
            isLoading: true,
            progress: 0,
            status: 'downloading',
            showOpenButton: false
        });

        try {
            const response = await fetch(pdfFile);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const contentLength = response.headers.get('Content-Length');
            const total = parseInt(contentLength || '0', 10);
            let loaded = 0;

            const reader = response.body.getReader();
            const chunks = [];

            while (true) {
                const { done, value } = await reader.read();

                if (done) break;

                chunks.push(value);
                loaded += value.length;

                // Update progress
                if (total > 0) {
                    const percent = Math.round((loaded / total) * 100);
                    setDownloadState(prev => ({
                        ...prev,
                        progress: percent
                    }));
                } else {
                    // If we don't know total size, show indeterminate progress
                    const percent = Math.min(loaded / (1024 * 1024) * 10, 95);
                    setDownloadState(prev => ({
                        ...prev,
                        progress: Math.round(percent)
                    }));
                }
            }

            // Complete the progress
            const blob = new Blob(chunks, { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            setDownloadState({
                isLoading: false,
                progress: 100,
                status: 'complete',
                blobUrl: blobUrl,
                showOpenButton: true
            });

        } catch (error) {
            console.error('Error downloading PDF:', error);
            setDownloadState({
                isLoading: false,
                progress: 0,
                status: 'error',
                blobUrl: null,
                showOpenButton: false
            });
        }
    };

    const handleOpenPDF = () => {
        if (downloadState.blobUrl) {
            window.open(downloadState.blobUrl, '_blank');
        } else {
            // Fallback: open original PDF file
            window.open(pdfFile, '_blank');
        }
    };

    // Clean up blob URLs when component unmounts
    useEffect(() => {
        return () => {
            if (downloadState.blobUrl) {
                URL.revokeObjectURL(downloadState.blobUrl);
            }
        };
    }, [downloadState.blobUrl]);

    const getStatusMessage = () => {
        switch (downloadState.status) {
            case 'downloading':
                return {
                    className: 'status-message status-downloading',
                    content: '<i class="fas fa-sync-alt fa-spin"></i> Downloading PDF...'
                };
            case 'complete':
                return {
                    className: 'status-message status-complete',
                    content: '<i class="fas fa-check-circle"></i> Download Complete! Click "Open PDF" to view.'
                };
            case 'error':
                return {
                    className: 'status-message status-error',
                    content: '<i class="fas fa-exclamation-circle"></i> Download failed. Please try again.'
                };
            default:
                return null;
        }
    };

    const statusMessage = getStatusMessage();
    const [dounloadPdfs, setDounloadPdfs] = useState([]);




    useEffect(() => {
        const storedDounloadPdfs = JSON.parse(localStorage.getItem('savePdfIdInLocalStorage')) || [];
        setDounloadPdfs(storedDounloadPdfs);
    }, []);

    const storeDounloadPdf = (fileId) => {
        const storedPdfIdInLocalStorage = JSON.parse(localStorage.getItem('savePdfIdInLocalStorage')) || [];
        if (!storedPdfIdInLocalStorage.includes(fileId)) {
            const updatedsavePdfInLocalStorage = [...storedPdfIdInLocalStorage, fileId];
            localStorage.setItem('savePdfIdInLocalStorage', JSON.stringify(updatedsavePdfInLocalStorage));
        }

    };

    const isPdfDounloaded = dounloadPdfs.some(
        dounloadedpdf => dounloadedpdf === fileId
    );


    return (
        <div className="pdf-card">


            <div className="pdf-info">

                <div className="pdf-detail">
                    <p>📄 {title}</p>

                </div>
                {!isOnline ? (<><p style={{ color: 'red' }}> You are offline </p> </>) : (<></>)}
            </div>


            {/*
            <Link to={`/onlinereadbook/${type}/${subject}/${topic}`} className='link'  >
                <p
                style={{background: "blue",borderRadius:"10px",padding:"10px",color:"white",textDecoration:"none"}}
                > 📄 View file online</p>
            </Link><br></br>
            */}



            <div className="pdf-action" >
                {isPdfDounloaded ? (<>

                    < a href={pdfFile} className="btn btn-open" rel="noopener noreferrer" >
                        📄 Open PDF File
                    </a>
                    {isPdfDounloaded && <p style={{ fontSize: "10px", color: "green" }}>Downloaded</p>}

                </>) : (<>


                    {isOnline ? (<>
                        <button
                            className={`btn btn-download-view ${downloadState.isLoading ? 'loading' : ''}`}
                            onClick={() => {
                                handleDownload();
                                storeDounloadPdf(fileId);
                            }}
                            disabled={downloadState.isLoading}  >
                            <i className="fas fa-download"></i>
                            📄 Download PDF File
                        </button>
                    </>) : (<>
                        <p style={{ background: 'red', color: 'white', padding: '8px', borderRadius: '10px', fontSize: '15px' }}>
                            Connect to the internet to download.
                        </p>
                    </>)}



                </>)}




                {(downloadState.status === 'downloading' || downloadState.status === 'complete') && (
                    <div className="progress-container">

                        <div
                            className="progress-bar"
                            style={{ width: `${downloadState.progress}%` }}
                        >
                            <div className="progress-info">
                                <span className="progress-percentage">{downloadState.progress}%</span>
                            </div>

                        </div>
                    </div>
                )}



                {downloadState.showOpenButton && (

                    < a href={pdfFile} className="btn btn-open" rel="noopener noreferrer" >
                        📄 Open PDF File
                    </a>

                )}
            </div>


        </div >
    );
};

const PDFViewer = () => {
    const [successMessage, setSuccessMessage] = useState({
        show: false,
        text: '',
        isError: false
    });

    //  ${pdf.pdfPath}/${pdf.name}/${pdf.id}

    //    const { pdfId, pdfName, fileId } = useParams();

    const { id } = useParams();

    const targetFile = PdfFiles.find(file => file.id === id);
    const type = targetFile?.type;
    const subject = targetFile?.subject;
    const topic = targetFile?.topic;

    const pdfId = targetFile?.pdfPath;
    const pdfName = targetFile?.name;
    const fileId = targetFile?.id;


    const pdfFiles = [
        {
            pdfFile: `/pdfs/${pdfId}`,
            fileName: pdfName,
            title: pdfName,
        }
    ];

    // Check for PDF files on component mount
    useEffect(() => {
        const checkPDFFiles = async () => {
            const missingFiles = [];

            for (const file of pdfFiles) {
                try {
                    const response = await fetch(file.pdfFile, { method: 'HEAD' });
                    if (!response.ok) {
                        missingFiles.push(file.pdfFile);
                    }
                } catch (error) {
                    missingFiles.push(file.pdfFile);
                }
            }

            if (missingFiles.length > 0) {
                console.warn('The following PDF files are missing:', missingFiles);
                console.log('Please make sure these files are in the public directory:');
                missingFiles.forEach(file => console.log(`- ${file}`));
            } else {
                console.log('All PDF files are present and accessible.');
            }
        };

        checkPDFFiles();
    }, []);

    return (
        <div className="container">
            <div className="header">
                <TopNavbar name="Download and view PDF files" />



            </div>

            {successMessage.show && (
                <div className={`success-message ${successMessage.isError ? 'error' : ''}`}>
                    <i className={`fas ${successMessage.isError ? 'fa-exclamation-circle' : 'fa-check-circle'}`}></i>
                    <span>{successMessage.text}</span>
                </div>
            )}

            {pdfFiles.map((file, index) => (
                <PDFCard
                    key={index}
                    type={type}
                    subject={subject}
                    topic={topic}
                    pdfFile={file.pdfFile}
                    title={file.title}
                    fileId={fileId}
                />
            ))}
        </div>
    );
};

export default PDFViewer;